import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import Layout from './components/Layout';
import Home from './pages/Home';
import Admin from './pages/Admin';
import Login from './pages/Login';
import Assessment from './pages/Assessment';
import AssessmentResult from './pages/AssessmentResult';
import AssessmentSelector from './pages/AssessmentSelector';
import MoebiusBleed from './pages/MoebiusBleed';
import MoebiusComparison from './pages/MoebiusComparison';

const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID;

function ProtectedApp() {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <p style={{ color: '#718096' }}>Loading...</p>
      </div>
    );
  }

  if (!user) return <Login />;

  return (
    <Layout>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/admin" element={<Admin />} />
        <Route path="/assessment/new" element={<AssessmentSelector />} />
        <Route path="/assessment/moebius-replacement/new" element={<Assessment />} />
        <Route path="/assessment/moebius-bleed/new" element={<MoebiusBleed />} />
        <Route path="/assessment/moebius-comparison/new" element={<MoebiusComparison />} />
        <Route path="/assessment/:id" element={<AssessmentResult />} />
      </Routes>
    </Layout>
  );
}

export default function App() {
  return (
    <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
      <AuthProvider>
        <ProtectedApp />
      </AuthProvider>
    </GoogleOAuthProvider>
  );
}

